import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; // ✅ Initialize navigation
import "../../styles/PagesStyling/HomePage.css";
import { SignUpForm } from "../AdminComponents/SignUpForm";
import { LoginForm } from "../HomeComponents/LoginForm";

export const HomePage = ({
  isLoggedIn,
  userData,
  setIsLoggedIn,
  setUserData,
}) => {
  const [showSignUp, setShowSignUp] = useState(false);
  // const [showLoginForm, setShowLoginForm] = useState(true);
  const navigate = useNavigate(); // ✅ Initialize navigation
  const LoginImage = `${process.env.PUBLIC_URL}/assets/images/LWC-Login-Full-Image.svg`

  useEffect(() => {
    // Redirect to dashboard if logged in
    if (isLoggedIn && userData) {
      navigate("/dashboard");
    }
  }, [isLoggedIn, userData, navigate]);

  return (
    <div className="homepage-container">
      {/* <h1>Live Well Collaborative</h1> */}
      {isLoggedIn && userData ? (
        <h1>Welcome Back, {userData.FullName}!</h1> // Correct rendering of userData.FullName
      ) : (
        <>
          <div className="left-container">
            <LoginForm
              setIsLoggedIn={setIsLoggedIn}
              setUserData={setUserData}
              closeForm={() => {
                return;
              }}
            />
          </div>
          <div
            className="right-container"
            style={{
              backgroundImage: `url(${LoginImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            {" "}
          </div>
        </>
      )}
      {/* <div>
        <button className="login-btn" onClick={() => setShowSignUp(true)}>
          Sign Up
        </button>
      </div>
      {showSignUp && <SignUpForm closeForm={() => setShowSignUp(false)} />} */}
    </div>
  );
};
